import { useState } from 'react';

import EyeCloseIcon from '@/fo/icons/base/icons/pass_hide.svg';
import EyeIcon from '@/fo/icons/base/icons/pass_open.svg';
import { UiKitInputBaseProps, UiKitInputBase } from '@/fo/ui/kit/input/base';

export type UiKitInputPasswordProps = UiKitInputBaseProps;

export function UiKitInputPassword({ ...props }: UiKitInputPasswordProps) {
  const [inputType, setInputType] = useState<'password' | 'text'>('password');

  const renderPasswordIcon = () => {
    return (
      <button
        type="button"
        onClick={() =>
          setInputType(inputType === 'password' ? 'text' : 'password')
        }
      >
        {inputType === 'password' ? <EyeCloseIcon /> : <EyeIcon />}
      </button>
    );
  };

  return (
    <UiKitInputBase
      {...props}
      type={inputType}
      icon={renderPasswordIcon()}
    />
  );
}
